// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1UEdj","tab":"ProcedureTabs_tab__zawHt"};